<rt-dialog-header
  [heading]="'tlc.company_verification.dialog.heading' | translate"
  [subheading]="'tlc.company_verification.dialog.subheading' | translate"
>
</rt-dialog-header>
<rt-dialog-body variant="white">
  <form [formGroup]="form" layout-full-width>
    <rt-form-field>
      <rt-label>{{ 'tlc.company_verification.dialog.form.name' | translate }}</rt-label>
      <rt-input formControlName="companyName"></rt-input>
    </rt-form-field>

    <rt-form-field margin-right-small-x>
      <rt-label>{{ 'tlc.company_verification.dialog.form.website' | translate }}</rt-label>
      <rt-input formControlName="companyWebsite"></rt-input>
    </rt-form-field>

    <rt-form-field>
      <rt-label>{{ 'tlc.company_verification.dialog.form.address' | translate }}</rt-label>
      <rt-input formControlName="companyAddress"></rt-input>
    </rt-form-field>

    <rt-form-field>
      <rt-label>{{ 'tlc.company_verification.dialog.form.country' | translate }}</rt-label>
      <rt-select
        [options]="countries"
        [includeEmptyOption]="false"
        formControlName="companyCountryCode"
      ></rt-select>
    </rt-form-field>

    <rt-form-field>
      <rt-label> {{ 'tlc.company_verification.dialog.form.tax_number' | translate }}</rt-label>
      <rt-icon-help
        [rtTooltip]="'tlc.company_verification.dialog.tax_number_tooltip' | translate"
        margin-left-small-xx
      ></rt-icon-help>

      <rt-input formControlName="companyTaxNumber"></rt-input>
    </rt-form-field>
  </form>
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button (click)="cancel()" variant="plain">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button
    (click)="continue()"
    [loading]="loading()"
    [disabled]="!form.valid"
    variant="primary"
    >{{ 'tlc.company_verification.dialog.form.continue' | translate }}</rt-button
  >
</rt-dialog-footer>
